<template>
  <a-drawer
    :visible="visible"
    title="Editar datos personales"
    destroy-on-close
    :mask-closable="false"
    placement="right"
    width="480"
    keyboard
    :body-style="{ padding: 0 }"
    @close="handleCloseDrawer"
  >
    <custom-scrollbar class="modal__body" height="calc(100vh - 108px)">
      <a-alert class="alert" type="warning" show-icon v-if="hasHubspotExport">
        <template #message>
          Todo cambio desde BeexCC a datos exportados se podrán <span class="soft-bold">actualizar manualmente</span> hacia HubSpot.
        </template>
      </a-alert>
      <a-form
        v-if="dataClient"
        class="form"
        layout="vertical"
        ref="formRef"
        :model="formState"
        @submit.prevent="handleSubmit"
      >
        <div v-for="item in columns" :key="item.index">
          <a-form-item v-if="item.title == 'code'" label="Código" name="code">
            <a-input v-model:value="formState.code" disabled />
          </a-form-item>
          <a-form-item v-else :name="item.dataIndex">
            <template #label>
              {{ item.title }}
              <HubspotIcon
                v-if="item?.hubspot_property"
                :color="item?.hubspot_synced ? undefined : '#8C8C8C'"
                style="margin-left: 5px"
                size="14"
              />
            </template>
            <a-select
              v-if="isSelectField(item)"
              v-model:value="formState[item.dataIndex]"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              class="form__select"
              show-search
              :filter-option="false"
              :options="selectFieldsState[item.dataIndex]?.options || []"
              :loading="selectFieldsState[item.dataIndex]?.loading"
              placeholder="Seleccionar"
              @search="handleSelectSearch(item, $event)"
              @popupScroll="handleSelectScroll(item, $event)"
            >
              <template #notFoundContent>
                <div class="form__empty-options">
                  <SearchOutlined class="form__empty-options-icon" />
                  <span>No se encontraron resultados a tu búsqueda</span>
                </div>
              </template>
            </a-select>
            <a-input
              v-else
              v-model:value="formState[item.dataIndex]"
            />
          </a-form-item>
        </div>
      </a-form>
    </custom-scrollbar>

    <div class="footer">
      <a-button class="footer__button" @click="handleCloseDrawer"> Cancelar </a-button>
      <a-button type="primary" @click="handleSubmit" :loading="loading"> Guardar cambios </a-button>
    </div>
  </a-drawer>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { defineComponent, ref, reactive, toRaw, inject } from "vue";
import httpManager, { ResponseError } from "@/app/shared/utils/httpManager";
import EventBus from "@/app/shared/utils/eventBus";
import HubspotIcon from "@/app/integrations/components/icons/HubspotIcon.vue";
import { HubspotIntegrationType } from "@/app/integrations/utils/enums";
import { ModeFetchWorkspace } from "@/app/workspace/utils/enums";
import { SearchOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    CustomScrollbar,
    HubspotIcon,
    SearchOutlined,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    itemId: {
      type: Number || String,
      required: true,
    },
  },
  setup() {
    const formRef = ref();
    const formState = reactive({});
    const loading = ref(false);

    const loadingTableData = inject("loadingTableData");

    return {
      formState,
      formRef,
      loadingTableData,
      loading,
      ModeFetchWorkspace,
    };
  },
  data() {
    return {
      customFields: {},
      selectFieldsState: {},
      selectSearchTimer: null,
    };
  },
  computed: {
    dataClient() {
      return this.$store.getters["getCustomerPersonalData"];
    },
    getColumns() {
      return this.$store.getters["getPersonalInformation"];
    },
    columns() {
      let cols = this.getColumns;
      cols = cols.filter((col) => col.title != "id" && col.title != "Acciones");
      return cols;
    },
    hasHubspotExport() {
      return this.$store.getters.hasHubspotByCode(HubspotIntegrationType.Export);
    },
    contactExportedHubspot() {
      console.log(this.dataClient, 'this.dataClient')
      if (this.dataClient)
        return this.dataClient?.hubspot_export
      return null;
    },
  },
  watch: {
    visible(value) {
      if (value) {
        const data = this.dataClient;
        this.selectFieldsState = {};

        this.columns.forEach((column) => {
          const fieldValue = data[column.dataIndex];
          this.formState[column.dataIndex] = this.isSelectField(column)
            ? fieldValue == null ? undefined : String(fieldValue)
            : fieldValue;

          if (this.isSelectField(column)) {
            const options = column.options || [];
            this.selectFieldsState[column.dataIndex] = {
              options: this.toSelectOptions(options),
              offset: options.length,
              search: "",
              hasMore: options.length < column.options_count,
              loading: false,
              requestId: 0,
            };
          }
        });
      }
    },
  },
  beforeUnmount() {
    clearTimeout(this.selectSearchTimer);
  },
  methods: {
    isSelectField(field) {
      return field?.field_type === "select";
    },
    toSelectOptions(values) {
      return values.map((option) => {
        const value = typeof option === "object" ? option.value : option;
        return { label: value, value: String(value) };
      });
    },
    handleSelectSearch(field, value) {
      clearTimeout(this.selectSearchTimer);
      this.selectSearchTimer = setTimeout(
        () => this.fetchSelectOptions(field, value.trim(), true),
        300,
      );
    },
    handleSelectScroll(field, event) {
      const target = event.target;
      const isNearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 24;

      if (isNearBottom) this.fetchSelectOptions(field);
    },
    async fetchSelectOptions(field, search, reset = false) {
      const state = this.selectFieldsState[field.dataIndex];
      if (!state || !field.options_url || (!reset && (state.loading || !state.hasMore))) return;

      const requestedSearch = reset ? search : state.search;
      const offset = reset ? 0 : state.offset;
      const requestId = state.requestId + 1;
      state.requestId = requestId;
      state.loading = true;

      try {
        const separator = field.options_url.includes("?") ? "&" : "?";
        const query = new URLSearchParams({
          limit: "50",
          offset: String(offset),
        });

        if (requestedSearch) query.set("search", requestedSearch);

        const response = await httpManager.get(`${field.options_url}${separator}${query}`);
        if (state.requestId !== requestId) return;

        const options = this.toSelectOptions(response.data.results || []);
        state.options = reset ? options : [...state.options, ...options];
        state.offset = offset + options.length;
        state.search = requestedSearch;
        state.hasMore = Boolean(response?.data?.next);
      } catch {
        if (state.requestId === requestId) {
          this.$message.error("No se pudieron cargar las opciones del campo.");
        }
      } finally {
        if (state.requestId === requestId) state.loading = false;
      }
    },
    handleCloseDrawer() {
      this.$emit("onCloseDrawerEdit");
    },
    handleSubmit() {
      this.loadingTableData = true;
      this.formRef.validateFields().then(async () => {
        this.loading = true;
        try {
          await this.$store.dispatch("updateInformationPersonal", {
            contactId: this.itemId,
            body: toRaw(this.formState),
          });
          await this.$store.dispatch("fetchCustomerPersonalData", this.itemId);
          this.handleCloseDrawer();
          this.$message.success("Se ha editado información correctamente");
          EventBus.emit("UPDATE_DATA_CONTACT");
          this.$store.dispatch("fetchActiveWorkspaceTickets", {
            mode: ModeFetchWorkspace.RefreshByTicket,
            ticketId: this.$route.query.ticket,
          });
          this.$emit("update");
        } catch (error) {
          let errorMessage = "Ha ocurrido un error";

          if (error instanceof ResponseError) errorMessage = error.getErrorMessage();

          this.$message.error(errorMessage);
          // this.$message.error("Se ha producido un error al editar la información");
        }
        this.loading = false;
      });
      this.loadingTableData = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.modal
  &__body
    padding: 12px 24px

.footer
  display: flex
  align-items: center
  justify-content: flex-end
  padding: 10px 16px
  border-top: $border-normal
  position: absolute
  width: 100%
  bottom: 0
  left: 0

  &__button
    margin-right: 12px

.flex-column
  display: flex
  flex-direction: column

:deep(.ant-calendar-picker)
  width: 100%
  
.alert
  margin-bottom: 10px

.soft-bold
  font-weight: 600

.form__select
  width: 100%

.form
  &__empty-options
    display: flex
    min-height: 100px
    flex-direction: column
    align-items: center
    justify-content: center
    gap: 8px
    text-align: center

  &__empty-options-icon
    font-size: 40px
</style>
